/**
 * Rutas tenant que montan el lienzo operativo POS (Cuenta + Cobrar a altura completa)
 * sin cambiar el rail a shell POS.
 *
 * - `/sales/pos/*` — estación embebida legacy
 * - `/sales/orders/nuevo` y `/sales/orders/:draftId` — Pedidos → Mostrador (`PosOrdersCounterPage`)
 *
 * La lista `/sales/orders` NO es canvas (hub de pedidos).
 */
export function isTenantEmbeddedPosCanvasPath(urlOrPath: string): boolean {
  const path = (urlOrPath.split('?')[0] || '').trim();
  if (path === '/sales/pos' || path.startsWith('/sales/pos/')) {
    return true;
  }
  if (path === '/sales/orders/nuevo') {
    return true;
  }
  return /^\/sales\/orders\/[^/]+$/.test(path);
}
